module.exports = __webpack_public_path__ + "static/005-9c493276b878e7d37568e9b23c8646ee.jpg";